﻿<template>
  <div class="page ann-page">
    <template v-if="mainTab === 'platform'">
      
      <div class="ann-sticky-top">
        <div class="sub-head">
          <div class="sub-tabs">
            <button
                v-for="t in mainTabs"
                :key="t.key"
                type="button"
                class="sub-tab"
                :class="{ active: mainTab === t.key }"
                @click="mainTab = t.key"
            >
              {{ t.label }}
            </button>
          </div>
          <van-icon name="replay" class="replay" @click="refreshAll" />
        </div>
        <div class="filter-row">
          <van-icon name="search" class="search-ico" @click="showSearch = true" />
          <div class="chips">
            <button
                v-for="c in categoryChips"
                :key="c"
                type="button"
                class="chip"
                :class="{ on: activeChip === c }"
                @click="onChip(c)"
            >
              {{ c }}
            </button>
          </div>
        </div>
      </div>

      <div class="ann-pull-wrap">
        <van-pull-refresh v-model="refreshing" @refresh="onPullRefresh">
        <div v-if="loading && rawList.length === 0" class="state-wrap">
          <van-loading size="28" />
        </div>
        <van-empty v-else-if="!loading && filteredList.length === 0" description="暂无公告" />

        <div v-else class="card-list">
          <div
              v-for="row in filteredList"
              :key="row.notice_id || row.detail_url"
              class="ann-card"
              @click="goDetail(row)"
          >
            <div class="ann-card-main">
              <div class="ann-title">{{ displayTitle(row) }}</div>
              <div class="ann-meta">
                <span class="cat-tag">{{ row.category || '公告' }}</span>
                <span class="ann-time">{{ row.publish_time }}</span>
              </div>
            </div>
            <div class="ann-thumb-wrap">
              <img
                  v-if="thumbUrl(row.cover_img)"
                  :src="thumbUrl(row.cover_img)"
                  class="ann-thumb"
                  alt=""
              >
              <div
                  v-else
                  :class="['ann-thumb', 'ph', coverThemeClass(row)]"
                  :aria-label="displayTitle(row)"
              >
                <div class="ph-mesh" aria-hidden="true" />
                <div class="ph-shine ph-shine--a" aria-hidden="true" />
                <div class="ph-shine ph-shine--b" aria-hidden="true" />
                <div class="ph-typo">{{ coverDisplayLabel(row) }}</div>
              </div>
              <button
                  type="button"
                  class="fav-btn"
                  @click.stop="toggleStar(row.notice_id)"
              >
                <van-icon :name="isStarred(row.notice_id) ? 'like' : 'like-o'" />
                关注
              </button>
            </div>
          </div>
        </div>
        </van-pull-refresh>
      </div>
    </template>

    <template v-else>
      <div class="ann-sticky-top ann-sticky-top--solo">
        <div class="sub-head">
          <div class="sub-tabs">
            <button
                v-for="t in mainTabs"
                :key="t.key"
                type="button"
                class="sub-tab"
                :class="{ active: mainTab === t.key }"
                @click="mainTab = t.key"
            >
              {{ t.label }}
            </button>
          </div>
          <van-icon name="replay" class="replay" @click="refreshAll" />
        </div>
      </div>
      <div class="placeholder-tab">
        <van-empty description="敬请期待" />
      </div>
    </template>

    <van-popup v-model:show="showSearch" position="top" :style="{ paddingTop: '12px' }">
      <van-search
          v-model="searchKw"
          show-action
          placeholder="搜索标题"
          @search="applySearch"
          @cancel="showSearch = false"
      />
    </van-popup>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { showToast } from "vant";
import { fetchYstNoticeList } from "@/api/ystAnnouncements";
import { resolveCdnUrl } from "@/utils/cdn";
import { saveNoticeMeta } from "@/utils/noticeMetaStorage";
const route = useRoute();
const router = useRouter();
const mainTabs = [
    { key: "platform", label: "\u5E73\u53F0\u516C\u544A" },
    { key: "news", label: "\u65B0\u95FB\u53D1\u58F0" },
    { key: "rumor", label: "\u8F9F\u8C23\u5899" }
];
const mainTab = ref("platform");
const categoryChips = ["\u5168\u90E8", "\u5BC4\u552E\u516C\u544A", "\u6D3B\u52A8\u516C\u544A", "\u4E0A\u65B0\u516C\u544A"];
const activeChip = ref("\u5168\u90E8");
const searchKw = ref("");
const appliedSearch = ref("");
const showSearch = ref(false);
const rawList = ref([]);
const loading = ref(false);
const refreshing = ref(false);
const filteredList = computed(() => {
    let rows = rawList.value;
    const chip = activeChip.value;
    if (chip && chip !== "\u5168\u90E8") {
        rows = rows.filter((r) => (r.category || "").includes(chip.replace(/鍏憡$/, "")) || (r.category || "").includes(chip));
    }
    const q = appliedSearch.value.trim();
    if (q) {
        rows = rows.filter((r) => (r.title || "").includes(q));
    }
    return rows;
});
const STAR_KEY = "lst_ann_starred";
const starred = ref(new Set());
function loadStars() {
    try {
        const raw = localStorage.getItem(STAR_KEY);
        if (raw) {
            const arr = JSON.parse(raw);
            if (Array.isArray(arr))
                starred.value = new Set(arr.map(String));
        }
    }
    catch (e) {
    }
}
function saveStars() {
    try {
        localStorage.setItem(STAR_KEY, JSON.stringify([...starred.value]));
    }
    catch (e) {
    }
}
function isStarred(id) {
    return starred.value.has(String(id));
}
function toggleStar(id) {
    const k = String(id);
    if (starred.value.has(k))
        starred.value.delete(k);
    else
        starred.value.add(k);
    starred.value = new Set(starred.value);
    saveStars();
}
function thumbUrl(cover) {
    if (!cover || !String(cover).trim())
        return "";
    const s = String(cover).trim();
    if (s.startsWith("//"))
        return `https:${s}`;
    return resolveCdnUrl(s);
}
function displayTitle(row) {
    return (row.title || "").trim() || "\uFF08\u65E0\u6807\u9898\uFF09";
}
/** 娓愬彉搴曚粛鎸夈€屽垎绫?鏍囬銆嶅叧閿瘝鍒嗚壊锛涗腑澶櫧瀛椾富鏂囨鍙栥€屾爣棰樸€嶄笌鍙傝€冧骇鍝佷竴鑷达紝鏃犳爣棰樻椂鎵嶉€€鍥炲垎绫汇€?*/
function coverThemeClass(row) {
    const c = String(row.category || "") + String(row.title || "");
    if (c.includes("\u4E0A\u65B0") || c.includes("\u4E0A\u67B6")) {
        return "ph--new";
    }
    if (c.includes("\u6D3B\u52A8")) {
        return "ph--activity";
    }
    if (c.includes("\u5BC4\u552E") || c.includes("\u4E8C\u7EA7")) {
        return "ph--consign";
    }
    if (c.includes("\u7CFB\u7EDF") || c.includes("\u5408\u89C4") || c.includes("\u8F9F\u8C23")) {
        return "ph--system";
    }
    return "ph--default";
}
function coverDisplayLabel(row) {
    const t = (row.title || "").trim();
    if (t) {
        return t;
    }
    return (row.category || "\u516C\u544A").trim() || "\u516C\u544A";
}
async function loadList() {
    loading.value = true;
    try {
        rawList.value = await fetchYstNoticeList();
    }
    catch (e) {
        rawList.value = [];
        showToast(e.message || "\u52A0\u8F7D\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC\u6216\u7A0D\u540E\u91CD\u8BD5");
    }
    finally {
        loading.value = false;
        refreshing.value = false;
    }
}
function onChip(c) {
    activeChip.value = c;
}
function applySearch() {
    appliedSearch.value = searchKw.value;
    showSearch.value = false;
}
async function onPullRefresh() {
    refreshing.value = true;
    await loadList();
}
function refreshAll() {
    loadList();
}
function goDetail(row) {
    const id = row.notice_id != null ? String(row.notice_id) : "";
    if (!id && !row.detail_url) {
        showToast("无法打开详情");
        return;
    }
    const nid = id || "0";
    const meta = {
        title: displayTitle(row),
        category: row.category || "",
        publish_time: row.publish_time || "",
        cover: row.cover_img || "",
        detail_url: row.detail_url || ""
    };
    saveNoticeMeta(nid, meta);
    router.push({
        name: "AnnouncementDetail",
        params: { id: nid },
        state: { annMeta: meta }
    });
}
watch(mainTab, (m) => {
    if (m === "platform" && rawList.value.length === 0)
        loadList();
});
onMounted(() => {
    const kwParam = route.query.kw;
    if (kwParam) {
        searchKw.value = String(kwParam);
        appliedSearch.value = String(kwParam);
        showSearch.value = false;
    }
    loadStars();
    if (mainTab.value === "platform")
        loadList();
});
</script>

<style scoped>
/* 瑕嗙洊鍏ㄥ眬 .page 鐨?padding:15px锛岄伩鍏嶉粍鏉′笌 Tab 涔嬮棿鍑虹幇涓€鏉＄┖鐧?*/
.ann-page {
  height: 100%;
  min-height: 0;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--app-bg-page);
  padding: 0;
  box-sizing: border-box;
}


.ann-sticky-top {
  position: sticky;
  top: var(--app-top-banner-h, 0px);
  z-index: 20;
  background: var(--app-surface-glass);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.ann-sticky-top .sub-head {
  border-bottom: 1px solid var(--app-border-subtle);
}

.ann-sticky-top--solo .sub-head {
  border-bottom: none;
}

.sub-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 4px;
  background: var(--app-surface-glass);
}

.sub-tabs {
  display: flex;
  align-items: center;
  gap: 18px;
  flex: 1;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.sub-tabs::-webkit-scrollbar {
  display: none;
}

.sub-tab {
  border: none;
  background: none;
  padding: 8px 0;
  font-size: 15px;
  color: var(--app-text-secondary);
  white-space: nowrap;
  position: relative;
}

.sub-tab.active {
  color: var(--app-text-primary);
  font-weight: 700;
}

.sub-tab.active::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 28px;
  height: 3px;
  border-radius: 2px;
  background: var(--app-tab-ink, var(--app-accent));
}

.replay {
  font-size: 20px;
  color: var(--app-text-secondary);
  padding: 8px;
  flex-shrink: 0;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: var(--app-surface-glass);
  border-bottom: none;
}

.search-ico {
  font-size: 20px;
  color: var(--app-text-secondary);
  flex-shrink: 0;
}

.chips {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  flex: 1;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.chips::-webkit-scrollbar {
  display: none;
}

.chip {
  border: none;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  white-space: nowrap;
  background: rgba(0, 0, 0, 0.05);
  color: var(--app-text-secondary);
}

.chip.on {
  background: var(--app-pill-active-bg, #ff8c42);
  color: var(--app-pill-active-text, #fff);
  font-weight: 600;
}


.ann-pull-wrap {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  margin-top: 10px;
  padding-top: 6px;
  background: var(--app-bg-page);
}

.state-wrap {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}

.card-list {
  padding: 12px 12px 24px;
}

.ann-card {
  display: flex;
  gap: 12px;
  padding: 14px;
  margin-bottom: 10px;
  background: var(--app-surface-glass);
  border-radius: var(--app-card-radius, 14px);
  border: 1px solid var(--app-border-subtle);
  box-shadow: var(--app-card-shadow);
}

.ann-card-main {
  flex: 1;
  min-width: 0;
}

.ann-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--app-text-primary);
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ann-meta {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.cat-tag {
  display: inline-block;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  background: var(--app-badge-sale-bg);
  color: var(--app-badge-sale-text);
}

.ann-time {
  font-size: 12px;
  color: var(--app-text-muted);
}

.ann-thumb-wrap {
  position: relative;
  width: 96px;
  height: 72px;
  flex-shrink: 0;
}

.ann-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

/* 鏃犲皝闈?URL 鏃讹細娓愬彉搴?+ 涓绘枃妗?鏍囬锛堣 coverDisplayLabel锛夛紝涓庣珵鍝併€屽彸渚у浘浠ユ爣棰樹负瑙嗚涓讳俊鎭€嶄竴鑷?*/
.ann-thumb.ph {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
}

.ph-mesh {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.55;
  background-image:
    radial-gradient(ellipse 120% 80% at 50% 0%, rgba(255, 255, 255, 0.35) 0%, transparent 45%),
    radial-gradient(ellipse 60% 50% at 20% 100%, rgba(120, 200, 255, 0.25) 0%, transparent 50%),
    radial-gradient(ellipse 50% 40% at 90% 80%, rgba(200, 160, 255, 0.2) 0%, transparent 50%);
}

.ph-shine {
  position: absolute;
  pointer-events: none;
  border-radius: 50%;
  filter: blur(8px);
  opacity: 0.55;
}
.ph-shine--a {
  width: 140%;
  height: 40%;
  top: -8%;
  left: -20%;
  transform: rotate(-8deg);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(200, 230, 255, 0.45) 50%, rgba(255, 255, 255, 0) 100%);
}
.ph-shine--b {
  width: 60%;
  height: 50%;
  bottom: -10%;
  right: -5%;
  background: radial-gradient(circle, rgba(100, 200, 255, 0.35) 0%, transparent 70%);
}

.ph-typo {
  position: relative;
  z-index: 1;
  max-width: 100%;
  max-height: 100%;
  padding: 2px 2px 18px 2px;
  text-align: center;
  font-size: 9.5px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0.02em;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 30, 0.75), 0 0 8px rgba(120, 200, 255, 0.35);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
  box-sizing: border-box;
}
@media (min-width: 400px) {
  .ph-typo {
    font-size: 10px;
  }
}

.ann-thumb.ph--new {
  background: linear-gradient(145deg, #0a1f3d 0%, #0c4a6e 40%, #0369a1 100%);
}
.ann-thumb.ph--activity {
  background: linear-gradient(145deg, #3b0b5a 0%, #6b21a8 50%, #a855f7 100%);
}
.ann-thumb.ph--consign {
  background: linear-gradient(145deg, #044e45 0%, #0d9488 45%, #14b8a6 100%);
}
.ann-thumb.ph--system {
  background: linear-gradient(145deg, #1e1b4b 0%, #312e81 50%, #4338ca 100%);
}
.ann-thumb.ph--default {
  background: linear-gradient(145deg, #172554 0%, #1d4ed8 55%, #3b82f6 100%);
}

.fav-btn {
  z-index: 2;
  position: absolute;
  right: 4px;
  bottom: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
  border: none;
  border-radius: 999px;
  padding: 2px 6px;
  font-size: 10px;
  color: #333;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
}

.placeholder-tab {
  padding-top: 48px;
}

</style>
